import AgoraRTM from 'agora-rtm-sdk';
import {AgoraEventName, PeerMessageSendResult} from "../utis/customEnum";
import {Logger} from "../utis/Log";
import {isDebug} from "../appConfig";

export default class RTMClient{
	constructor(appId, eventCallback) {
		this.isLogined = false
		this._client = null
		this._localInvitation = null
		this._remoteInvitation = null

		this.eventCallback = eventCallback
		this._client = AgoraRTM.createInstance(appId, {logFilter: isDebug ? AgoraRTM.LOG_FILTER_INFO : AgoraRTM.LOG_FILTER_OFF})

		this.subscribeClientEvents()
	}

	subscribeClientEvents() {
		const events = [
			AgoraEventName.ConnectionStateChanged,
			AgoraEventName.MessageFromPeer,
			AgoraEventName.RemoteInvitationReceived,
			AgoraEventName.PeersOnlineStatusChanged,
		];
		events.forEach((eventName) => {
			Logger.print('rtm client event: ' + eventName)
			this._client && this._client.on(eventName, (event, ...args) => {
				if (eventName === AgoraEventName.RemoteInvitationReceived) {
					if (!this._remoteInvitation) {
						this._remoteInvitation = event

						this.subScribeRemoteInvitationEvents(this._remoteInvitation)
					}
				}
				this.eventCallback && this.eventCallback(eventName, event, ...args)
			});
		});
	}

	subScribeRemoteInvitationEvents() {
		if (!this._remoteInvitation) {
			return
		}

		const events = [
			AgoraEventName.RemoteInvitationAccepted,
			AgoraEventName.RemoteInvitationCanceled,
			AgoraEventName.RemoteInvitationFailure,
			AgoraEventName.RemoteInvitationRefused,
		];

		events.forEach((eventName) => {
			this._remoteInvitation.on(eventName, (event, ...args) => {
				Logger.print("rtm client remoteInvitation: " + eventName)
				this.eventCallback && this.eventCallback(eventName, event, ...args)

				if (eventName === AgoraEventName.RemoteInvitationCanceled ||
					eventName === AgoraEventName.RemoteInvitationCanceled ||
					eventName === AgoraEventName.RemoteInvitationRefused
				) {
					this._localInvitation = null
					this._remoteInvitation = null
				}
			})
		})
	}

	subscribeLocalInvitationEvents() {
		if (!this._localInvitation) {
			return
		}

		let events = [
			AgoraEventName.LocalInvitationAccepted,
			AgoraEventName.LocalInvitationFailure,
			AgoraEventName.LocalInvitationRefused,
			AgoraEventName.LocalInvitationCanceled,
			AgoraEventName.LocalInvitationReceivedByPeer,
		]
		events.forEach((eventName) => {
			this._localInvitation.on(eventName, (response) => {
				Logger.print('rtm client local invitation: ' + eventName)
				this.eventCallback && this.eventCallback(eventName, response)

				if (eventName === AgoraEventName.LocalInvitationCanceled ||
					eventName === AgoraEventName.LocalInvitationFailure ||
					eventName === AgoraEventName.LocalInvitationRefused
				) {
					this._localInvitation = null
					this._remoteInvitation = null
				}
			})
		})
	}

	subscribePeersOnlineStatus(peerIds) {
		this._client && this._client.subscribePeersOnlineStatus(peerIds)
	}

	login(myPhoneNumber, callback) {
		this._client && this._client.login({uid: myPhoneNumber, token: null}).then((response) => {
			this.isLogined = true
			callback && callback(true)
		}).catch(() => {
			this.isLogined = false
			callback && callback(false)
		})
	}

	logout() {
		if (!this.isLogined) {
			return
		}

		this._client && this._client.logout()
		this._client = null
		this.isLogined = false
	}

	queryPeersOnlineStatus(peerIds, callback) {
		if (!this.isLogined) {
			return callback && callback(null)
		}
		this._client && this._client.queryPeersOnlineStatus(peerIds).then((response) => {
			callback && callback(response)
		}).catch(() => {
			callback && callback(null)
		})
	}

	makeCall(callToNumber, channelId) {
		if (!this.isLogined) {
			return
		}

		this._localInvitation = this._client.createLocalInvitation(callToNumber)
		this.subscribeLocalInvitationEvents()

		this._localInvitation.channelId = channelId
		this._localInvitation.send()
	}

	cancelCall() {
		this._localInvitation && this._localInvitation.cancel()
		this._localInvitation = null
	}

	acceptCall() {
		this._remoteInvitation && this._remoteInvitation.accept()
	}

	refuseCall() {
		this._remoteInvitation && this._remoteInvitation.refuse()
		this._remoteInvitation = null
	}

	endCall(callback) {
		if (this._remoteInvitation) {
			this._remoteInvitation = null
		}
	}

	sendMessage(msg, callToNumber, callback) {
		this._client.sendMessageToPeer(
			{ text: msg },
			callToNumber,
			{enableOfflineMessaging: true}
		).then(sendResult => {
			if (sendResult.hasPeerReceived) {
				callback && callback(PeerMessageSendResult.success)
			} else {
				callback && callback(PeerMessageSendResult.peerOffline)
			}
		}).catch(error => {
			callback && callback(PeerMessageSendResult.fail)
		});
	}
}
